<template>
  <div>
    <div class="d-flex justify-content-between align-item-center mb-2">
      <div class="section-title mb-2">
        {{ $t("edit") }} {{ $tc("cinema", 1) }} {{ $tc("type", 1) }}
      </div>
      <router-link class="btn-blue" :to="{ name: 'Cinema Types' }"
        >{{ $tc("cinema", 1) }} {{ $tc("type", 2) }}
        {{ $tc("list", 1) }}</router-link
      >
    </div>

    <div class="white-wrapper">
      <div class="row">
        <div class="col-lg-6 col-xl-4 mb-4">
          <div class="d-flex align-items-center">
            <div class="input-material">
              <!-- @focus="onFocusHandler" -->
              <!-- :required="item.required" -->
              <input
                id="cinema_type_name"
                name="cinema_type_name"
                v-validate="'required|alpha_spaces'"
                v-model="cinema_type_name"
                placeholder="."
              />
              <label>Cinema Type Name</label>
            </div>
            <Tooltip :title="$t('cinema_type_name')" />
          </div>
          <p class="error_message">
            <span v-if="submitted && errors.has('cinema_type_name')">{{
              errors.first("cinema_type_name")
            }}</span>
          </p>
        </div>

        <div class="col-lg-6 col-xl-4 align-self-center mb-4">
          <div class="d-flex align-items-center">
            <b-form-checkbox
              class
              v-model="cine_type_is_active"
              unchecked-value="N"
              value="Y"
              switch
            ></b-form-checkbox>
            <span class="ml-3">{{ $t("active") }}</span>
          </div>
        </div>
      </div>

      <div class="text-center">
        <button @click.prevent.stop="editCinemaType()" class="btn-blue">
          {{ $t("update") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import MasterService from "@/services/MasterService";

export default {
  data() {
    return {
      submitted: false,
      cinema_type_name: "",
      cine_type_is_active: "Y",
      cinema_type_id: null
    };
  },
  mounted() {
    const { cinema_type_id } = this.$route.params;
    if (cinema_type_id) {
      this.getCinemaTypeData(cinema_type_id);
    } else {
      this.$router.go(-1);
    }
  },
  methods: {
    getCinemaTypeData: function(cinema_type_id) {
      MasterService.GetCinemaTypeData({ cinema_type_id: cinema_type_id })
        .then(response => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            this.cinema_type_name = data.Records[0].cinema_type_name;
            this.cine_type_is_active = data.Records[0].cine_type_is_active
              ? data.Records[0].cine_type_is_active
              : "N";
            this.cinema_type_id = data.Records[0].cinema_type_id;
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(error => {
          this.$toasted.show(error);
        });
    },
    editCinemaType() {
      this.submitted = true;
      this.$validator.validate().then(valid => {
        if (valid) {
          // let loader = this.$loading.show();

          // console.log("JSON.stringify :", JSON.stringify(finalObj));
          let payload = {
            cinema_type_id: this.cinema_type_id,
            cinema_type_name: this.cinema_type_name,
            cine_type_is_active: this.cine_type_is_active
          };
          MasterService.EditCinemaType(payload)
            .then(response => {
              const { data } = response;
              // loader.hide();
              if (data && data.status) {
                this.$toasted.show(data.message);

                this.$router.push({
                  path: "/master/cinema-types"
                });
              } else {
                this.$toasted.show(data.message);
              }
            })
            .catch(this._CatchError);
        }
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/MasterContainer/CinemaTypeComponents/editCinemaType.vue